import React from 'react';
import { Paper, Typography, Chip, Box } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';

interface JDPreviewProps {
  jdName: string;
  jdPreview: string;
  resumeCount: number;
  warnings: string[];
  skippedJds?: string[];
}

export default function JDPreview({
  jdName,
  jdPreview,
  resumeCount,
  warnings,
  skippedJds = [],
}: JDPreviewProps) {
  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
        bgcolor: 'rgba(16, 185, 129, 0.08)',
        border: '1px solid rgba(16, 185, 129, 0.3)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <DescriptionIcon color="success" />
        <Typography variant="subtitle1" fontWeight={600}>
          Job Description: {jdName}
        </Typography>
        <Chip
          label={`${resumeCount} resume${resumeCount !== 1 ? 's' : ''}`}
          color="primary"
          size="small"
          sx={{ ml: 'auto' }}
        />
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {jdPreview}
      </Typography>
      {warnings.length > 0 && (
        <Typography variant="caption" color="warning.main" display="block">
          Skipped (could not parse): {warnings.join(', ')}
        </Typography>
      )}
      {skippedJds.length > 0 && (
        <Typography variant="caption" color="warning.main" display="block">
          Skipped (looks like another job description, not a candidate):{' '}
          {skippedJds.join(', ')}
        </Typography>
      )}
    </Paper>
  );
}
